module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/227.4aea2245.png";